module.exports = __webpack_public_path__ + "assets/adpoly-facility-palm-trees-bulk-upload-template.97a6f39f.xlsx";